window.oxgCheckUncheckTarget = (btn, givenValue = null)=> {
  let targetId = btn.getAttribute('data-target')
  if(targetId) {
    let target = document.getElementById(targetId)
    if(target && target.tagName == 'INPUT') {
    let type = target.getAttribute('type')
    if(type == 'radio' || type == 'checkbox') {
      if(target.checked == true) {
      target.checked = false
      } else {
      target.checked = true
      }
    } else if ( type == 'hidden' ) {
      let theValue
      console.log(givenValue, typeof givenValue)
      if ((givenValue && typeof givenValue == 'string') || (givenValue && typeof givenValue == 'number')) {
        theValue = givenValue
      } else {
        theValue = 1
      }
      if (!target.value || target.value == 0) {
        target.value = theValue
      } else {
        target.value = null
      }
    }
    }
  }
}

window.oxgGetCheckboxes = (parentNode = null)=> {
  if (!parentNode) parentNode = document;
  let items = parentNode.querySelectorAll('.is-checkbox, input[type=checkbox], .is-radio, input[type=radio]')
  if (items) return items
}

window.oxgUncheckAll = (nodeList)=> {
  Array.from(nodeList).forEach(checkboxRadio => {
    console.log('unchecking', checkboxRadio)
    let classList = checkboxRadio.classList
    if (!classList.contains('no-remote-select') && !classList.contains('no-remote-uncheck')) {
      oxgUncheck(checkboxRadio)
    }
  })
}

window.oxgCheckAll = (nodeList)=> {
  Array.from(nodeList).forEach(checkboxRadio => {
    console.log('checking', checkboxRadio)
    let classList = checkboxRadio.classList
    if (!classList.contains('no-remote-select') && !classList.contains('no-remote-check')) {
      oxgCheck(checkboxRadio)
    }
  })
}

window.oxgCheck = (element)=> {
  if(element && element.tagName == 'INPUT') {
    let type = element.getAttribute('type')
    if(type == 'radio' || type == 'checkbox') {
      target.checked = true
    }
  } else if (element.classList.contains('is-checkbox') || element.classList.contains('is-radio')) {
    element.classList.add('is-checked')
  }
}

window.oxgUncheck = (element)=> {
  if(element && element.tagName == 'INPUT') {
    let type = element.getAttribute('type')
    if(type == 'radio' || type == 'checkbox') {
      target.checked = false
    }
  } else if (element.classList.contains('is-checkbox') || element.classList.contains('is-radio')) {
    element.classList.remove('is-checked')
  }
}

function oxg_form_styling() {
  let labels = document.querySelectorAll('label');
  let inputFields = document.querySelectorAll('input');
  for (let i = 0; i < labels.length; i++) {
    let label = labels[i];
    if ( label.querySelector('input') !== null && label.querySelector('.label-text') !== null ) {
      let labelText = label.querySelector('.label-text');
      let labelTextWidth = labelText.offsetWidth;
      let inputFieldId = label.getAttribute('for');
      let inputField = document.getElementById(inputFieldId);
      if(!inputField) {
        inputFields.forEach(field => {
          let name = field.getAttribute('name') ? field.getAttribute('name') : null
          if(name && name == inputFieldId) {
            inputField = field;
          }
        })
      }
      if(!inputField) {
        console.error('No matching input field found for label (at index ' + i + ')', label)
      } else {
        let inputFieldStyle = window.getComputedStyle(inputField);
        let inputFieldPaddingLeft = inputFieldStyle.getPropertyValue('padding-left');
        let labelInside = label.classList.contains('label-kinetic') || label.classList.contains('label-integrated') ? true : false;
        let labelChangeOnFocus = label.classList.contains('label-kinetic') ? true : false;
        if (inputField.getAttribute('disabled') == '') {
          label.classList.add('field-is-disabled');
        }
        if( inputField.value == '' ) {
          label.classList.remove('field-has-value');
          label.classList.add('field-is-empty');
        } else {
          label.classList.add('field-has-value');
          label.classList.remove('field-is-empty');
        }
        if (labelInside) inputField.style.paddingLeft = labelTextWidth + 'px';
        inputField.addEventListener('change', (e)=> {
          if( inputField.value == '' ) {
            label.classList.remove('field-has-value');
            label.classList.add('field-is-empty');
            if (labelChangeOnFocus) inputField.style.paddingLeft = inputFieldPaddingLeft;
          } else {
            label.classList.add('field-has-value');
            label.classList.remove('field-is-empty');
            if (labelChangeOnFocus) inputField.style.paddingLeft = labelTextWidth + 'px';
          }
        });
        inputField.addEventListener('focus', ()=> {
          label.classList.add('field-is-focused');
          if (labelChangeOnFocus) inputField.style.paddingLeft = inputFieldPaddingLeft;
        });
        inputField.addEventListener('focusout', ()=> {
          label.classList.remove('field-is-focused');
          if (labelChangeOnFocus) {
            inputField.style.paddingLeft = (inputField.value == '') ? labelTextWidth + 'px' : inputFieldPaddingLeft;
          }
        })
      }
    }
  }
}

function oxg_bricks_form_adjustments() {
  let bricksFormOptionsWrappers = document.querySelectorAll('.brxe-form .options-wrapper');
  if(!bricksFormOptionsWrappers) return;
  for (let i = 0; i < bricksFormOptionsWrappers.length; i++) {
    let wrapper = bricksFormOptionsWrappers[i];
    let radioCheckBoxes = wrapper.querySelectorAll('input[type=checkbox], input[type=radio]');
    if(radioCheckBoxes) {
      wrapper.classList.add('contains-radio-checkbox');
      let listItems = wrapper.querySelectorAll('li');
      if(listItems) {
        let listItemsArray = Array.from(listItems);
        let lastListItem = listItemsArray[listItemsArray.length - 1];
        lastListItem.classList.add('is-last');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  oxg_form_styling();
  oxg_bricks_form_adjustments();
});